import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../Icon/Icon';

import styles from './GenericCard.module.scss';

const GenericCard = ({ item }) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const { title, icon, description } = item;
  return (
    <div className={classnames(styles.container, isMounted && styles.fadeIn)}>
      <div className={styles.iconWrapper}>
        <Icon name={icon} />
      </div>
      <p className={styles.title}>{title}</p>
      <p className={styles.description}>{description}</p>
    </div>
  );
};

GenericCard.propTypes = {
  item: PropTypes.instanceOf(Object).isRequired,
};

// GenericCard.defaultProps = {
// };

export default GenericCard;
